module.exports = __webpack_public_path__ + "img/hubgrade-blanco.e4ca2983.svg";